import { NgModule } from '@angular/core';
import { Routes, RouterModule, ExtraOptions } from '@angular/router';
import { SubtitlesComponent } from './videoapp/components/subtitles/subtitles.component';
import { VideoAppComponent } from './videoapp/videoapp.component';

const routes: Routes = [
  { path: ':sess', component: VideoAppComponent },
  { path: '', component: VideoAppComponent },
  { path: 'subtitle', component: SubtitlesComponent },
  { path: '', redirectTo: '', pathMatch: 'full' },
  { path: '**', redirectTo: '' },
];

const config: ExtraOptions = {
    useHash: false,
    relativeLinkResolution: 'legacy'
}

@NgModule({
  imports: [RouterModule.forRoot(routes, config)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
